import type { FC } from "react";
import { memo } from "react";

import { useTranslations } from "@ui/providers/useTranslations";
import classNames from "classnames";

import { UiCrossIcon } from "@jti/brand-icons/ui-cross";

import styles from "./CloseButton.module.scss";

export type CloseButtonProps = {
  onClick?: (event: React.MouseEvent<HTMLElement>) => void;
  className?: string;
  dataTestId?: string;
  title?: string;
};

/**
 * @deprecated use RoundButton from @jti/ui instead with UiCrossIcon
 */

export const CloseButton: FC<CloseButtonProps> = memo(
  ({ onClick, className = "", dataTestId = "closeButton", title }) => {
    const { __ } = useTranslations();

    return (
      <button
        className={classNames(styles.close, className)}
        type="button"
        title={title}
        aria-label={__("common.close")}
        onClick={onClick}
        data-testid={dataTestId}
      >
        <UiCrossIcon className={styles.icon} aria-hidden="true" />
      </button>
    );
  }
);
